"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRating = exports.serializeRating = void 0;
const serializeRating = (item) => {
    return "★".repeat(item.data.value).padEnd(5, "☆");
};
exports.serializeRating = serializeRating;
const validateRating = (item) => {
    const hasData = item.data.value !== undefined;
    if (!item.required || hasData) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must choose rating value." } };
};
exports.validateRating = validateRating;
//# sourceMappingURL=rating.js.map